var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "productImageList" } }, [
    _c("div", { staticClass: "searchField" }, [
      _c("span", { staticClass: "searchButton" }, [
        _vm._v(_vm._s(_vm.translations.wsm_Search)),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.productSearchName,
            expression: "productSearchName",
          },
        ],
        staticClass: "search",
        attrs: {
          placeholder: _vm.translations.wsm_SearchboxPro,
          type: "text",
          "debounce-time": 100,
        },
        domProps: { value: _vm.productSearchName },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.productSearchName = $event.target.value
          },
        },
      }),
      !!_vm.getCategories.length
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass: "filterIcon",
                  on: {
                    click: function ($event) {
                      return _vm.toggleSettings()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-caret-down fa-2x",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm.showSettings
                ? _c("FilterProduct", {
                    attrs: { cat: _vm.getCategories, saveCat: _vm.selectedCat },
                    on: { setSelectedCat: _vm.setSelectedCat },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    !_vm.productSearchName
      ? _c(
          "div",
          { staticClass: "container" },
          _vm._l(_vm.images, function (product) {
            return _c(
              "div",
              { staticClass: "productHeader" },
              [
                product.name
                  ? _c("div", [
                      _c("h2", {
                        domProps: { innerHTML: _vm._s(product.name) },
                      }),
                    ])
                  : _c("div", [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.translations.wsm_proProducts)),
                      ]),
                    ]),
                _c("Loaders", { attrs: { "is-visible": _vm.isLoading } }),
                !_vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "listWrap1" },
                      _vm._l(
                        _vm.getImagesBySortNo(product.sortNo),
                        function (image) {
                          return _c("div", [
                            _c("div", { staticClass: "productImageWrap" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "fancybox",
                                  attrs: {
                                    href: _vm.imageUrl(
                                      image.imageUrl,
                                      image.sortNo
                                    ),
                                    title: image.name,
                                  },
                                },
                                [
                                  _c("v-lazy-image", {
                                    attrs: {
                                      src: _vm.imageUrl(
                                        image.imageUrl,
                                        image.sortNo
                                      ),
                                      alt: image.name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("p", {
                                domProps: { innerHTML: _vm._s(image.name) },
                              }),
                              _c("div", { attrs: { id: "productQuantity" } }, [
                                _vm._v("("),
                                _c("span", {
                                  attrs: { id: "pQ" },
                                  domProps: {
                                    innerHTML: _vm._s(image.quantityString),
                                  },
                                }),
                                _vm._v(")"),
                              ]),
                              _vm.showDownloadOptions(image.productId)
                                ? _c("div", { staticClass: "imageLinkWrap" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: image.name,
                                          href: _vm.checkImageUrl(
                                            image.imageUrl,
                                            "th"
                                          ),
                                          download: "",
                                        },
                                      },
                                      [_vm._v("Download (150px)")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: image.name,
                                          href: _vm.checkImageUrl(
                                            image.imageUrl,
                                            "th2"
                                          ),
                                          download: "",
                                        },
                                      },
                                      [_vm._v("Download (250px)")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: image.name,
                                          href: _vm.checkImageUrl(
                                            image.imageUrl,
                                            "th3"
                                          ),
                                          download: "",
                                        },
                                      },
                                      [_vm._v("Download (640px)")]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: image.name,
                                          href: _vm.checkImageUrl(
                                            image.imageUrl,
                                            "th4"
                                          ),
                                          download: "",
                                        },
                                      },
                                      [_vm._v("Download (980px)")]
                                    ),
                                    _vm.showFrontBackDownloadOption(
                                      image.productId
                                    )
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                title: image.name,
                                                href: _vm.fetchFrontImage(
                                                  image.sku_no || ""
                                                ),
                                                download: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Download (" +
                                                  _vm._s(
                                                    _vm.translations
                                                      .wsm_FrontPage
                                                  ) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                title: image.name,
                                                href: _vm.fetchBackImage(
                                                  image.sku_no || ""
                                                ),
                                                download: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Download (" +
                                                  _vm._s(
                                                    _vm.translations
                                                      .wsm_backPage
                                                  ) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _c("div", { staticClass: "imageLinkWrap" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: image.name,
                                          href: image.imageUrl,
                                          download: "",
                                        },
                                      },
                                      [_vm._v("Download Image")]
                                    ),
                                  ]),
                            ]),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "productHeader" },
          [
            _c("Loaders", { attrs: { "is-visible": _vm.isLoading } }),
            !_vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "listWrap1" },
                  _vm._l(_vm.images, function (image) {
                    return _c("div", { staticClass: "productImageWrap" }, [
                      _c(
                        "a",
                        {
                          staticClass: "fancybox",
                          attrs: {
                            href: _vm.imageUrl(image.imageUrl, image.sortNo),
                            title: image.name,
                          },
                        },
                        [
                          _c("v-lazy-image", {
                            attrs: {
                              src: _vm.imageUrl(image.imageUrl, image.sortNo),
                              alt: image.name,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("p", { domProps: { innerHTML: _vm._s(image.name) } }),
                      _c("div", { attrs: { id: "productQuantity" } }, [
                        _vm._v("("),
                        _c("span", {
                          attrs: { id: "pQ" },
                          domProps: { innerHTML: _vm._s(image.quantityString) },
                        }),
                        _vm._v(")"),
                      ]),
                      _vm.showDownloadOptions(image.productId)
                        ? _c("div", { staticClass: "imageLinkWrap" }, [
                            _c(
                              "a",
                              {
                                staticClass: "fancybox",
                                attrs: {
                                  title: image.name,
                                  href: _vm.checkImageUrl(image.imageUrl, "th"),
                                },
                              },
                              [_vm._v("Download (150px)")]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "fancybox",
                                attrs: {
                                  title: image.name,
                                  href: _vm.checkImageUrl(
                                    image.imageUrl,
                                    "th2"
                                  ),
                                },
                              },
                              [_vm._v("Download (250px)")]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "fancybox",
                                attrs: {
                                  title: image.name,
                                  href: _vm.checkImageUrl(
                                    image.imageUrl,
                                    "th3"
                                  ),
                                },
                              },
                              [_vm._v("Download (640px)")]
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "fancybox",
                                attrs: {
                                  title: image.name,
                                  href: _vm.checkImageUrl(
                                    image.imageUrl,
                                    "th4"
                                  ),
                                },
                              },
                              [_vm._v("Download (980px)")]
                            ),
                            _vm.showFrontBackDownloadOption(image.productId)
                              ? _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "fancybox",
                                      attrs: {
                                        title: image.name,
                                        href: _vm.fetchFrontImage(
                                          image.sku_no || ""
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Download (" +
                                          _vm._s(
                                            _vm.translations.wsm_FrontPage
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "fancybox",
                                      attrs: {
                                        title: image.name,
                                        href: _vm.fetchBackImage(
                                          image.sku_no || ""
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Download (" +
                                          _vm._s(
                                            _vm.translations.wsm_backPage
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _c("div", { staticClass: "imageLinkWrap" }, [
                            _c(
                              "a",
                              {
                                staticClass: "fancybox",
                                attrs: {
                                  title: image.name,
                                  href: image.imageUrl,
                                },
                              },
                              [_vm._v("Download Image")]
                            ),
                          ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }